<template>
  <DBox
    :id="'cmp-distribution-order-sidewindow-backorder'"
    :addButton="false"
    :addLink="false"
    :rightMenu="[
      {
        text: this.$t('auto_select'),
        value: 'auto_select',
      },
      {
        text: this.$t('Add Backorders'),
        value: 'add_backorders',
        disabled: selectedBackOrders.size > 0 ? false : true,
        disabledTooltip:
          selectedBackOrders.size > 0 ? '' : $t('select_backorders_to_add'),
      },
    ]"
    @menuClick="onRightMenuClick"
  >
    <NTable
      class="dbox1"
      id="distribution-order-sidewindow-backorder"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('date')">
            <span>{{ item["backorder_date"] }}</span>
          </td>
          <td v-bind="tdcon('product')">
            <div class="ut-flex">
              <div class="circular-status">
                <div
                  class="circular-status-color"
                  style="
                    width: 16px;
                    height: 16px;
                    border-radius: 50%;
                    margin-right: 8px;
                  "
                  :style="{
                    'background-color': `#${item['label_status_colour']}`,
                    border: item['label_status_colour']
                      ? `1px solid #${item['label_status_colour']}`
                      : '1px solid gray',
                  }"
                ></div>
              </div>

              <div class="ut-fc ut-txtov">
                <span
                  @click="onClickItem(item)"
                  class="ut-link ut-text-accent5 ut-txtov"
                  :title="item['catalog_no']"
                >
                  {{ item["catalog_no"] }}
                </span>
              </div>
            </div>
          </td>
          <td v-bind="tdcon('artist')">
            <span>{{ item["release_artist"] }}</span>
          </td>

          <td v-bind="tdcon('title1')">
            <span>{{ item["release_title"] }}</span>
          </td>
          <td v-bind="tdcon('format')">
            <span>{{ item["format_name"] }}</span>
          </td>

          <td v-bind="tdcon('stock')">
            <span>
              100000
              <!-- {{ item["account_stock_unpacked_unreserved"] }} -->
            </span>
          </td>
          <td v-bind="tdcon('quantity')">
            <TextField2
              type="text"
              class="dbox1"
              id="qty"
              :showLabel="false"
              :disabled="false"
              :value="item['qty']"
              :bb="'0px'"
              :ta="'right'"
              @change="(e) => onTextFieldChange(e, item)"
            />
          </td>
          <td v-bind="tdcon('N')">
            <span style="cursor: pointer" :title="item['available_hint']">{{
              item["product_allowed_country_account_show"]
            }}</span>
          </td>
          <!-- <td v-bind="tdcon('promo_foc')">
            <span>{{ item["promo_foc"] }}</span>
          </td> -->

          <td v-bind="tdcon('select')">
            <div class="ut-rowcen">
              <div class="dt-checkbox v2 s1">
                <input
                  class="disabled"
                  type="checkbox"
                  :name="'active_flag'"
                  :id="'active_flag'"
                  :checked="selectedBackOrders.has(item.backorder_id)"
                  @click="(e) => onCheckBoxChange(e, item)"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </td>

          <td v-bind="tdcon('options')">
            <div class="dt-icon-container">
              <img
                @click.stop="(e) => deleteBackorder(item)"
                src="static/icons/delete.svg"
                class="dt-icon v5 s1"
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { ConfirmationService } from "@/dt-plugins/confirmation/confirmation.service";
import { invoiceListLDTRoutes } from "../../../accounting/router/routes";
import { createConfirmResult } from "../../../../dt-plugins/confirmation/confirmation.service";
import { addRemoveSet } from "../../../../utility";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { productsListLDTRoutes } from "../../../catalog/router/routes";

export default {
  props: {
    selectedOrder: {
      type: Object,
    },
  },
  components: {
    NTable,
    DBox,
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
      },

      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      }),

      selectedBackOrders: new Set(),
      selectAll: false,
    };
  },
  computed: {
    Headers: function () {
      return [
        createTableHeader("date", { mw: 80 }),
        createTableHeader("product", {}),
        createTableHeader("artist", {}),

        createTableHeader("title1", { text: this.$t("title") }),
        createTableHeader("format", { ta: "right" ,mw:100}),

        createTableHeader("stock", { ta: "right" , mw:75}),
        createTableHeader("quantity", { ta: "right" , mw:75}),
        createTableHeader("N", { text: false, mw: 30 }),
        //createTableHeader("promo_foc", {}),
        createTableHeader("select", { ta: "center", mw: 60 }),
        createTableHeader("options", { text: false, mw: 30 }),
      ];
    },

    list: function () {
      return this.selectedOrder?.get_backorders?.backorders || [];
    },
  },

  methods: {
    onClickItem: function (item) {
      const { product_id } = item;

      this.$router.push({
        name: productsListLDTRoutes.names.tab,
        params: {
          product_id: product_id,
          tab: "overview",
        },
      });
    },
    onRightMenuClick: function (menu) {
      console.log(menu);
      if (menu == "auto_select") {
        // if (!this.selectAll) {
        //   this.selectAll = true;

        //   this.selectedBackOrders = new Set(
        //     this.selectedOrder?.get_backorders?.backorders.map(
        //       (e) => e.backorder_id
        //     )
        //   );
        // } else {
        //   this.selectAll = false;
        //   this.selectedBackOrders = new Set();
        // }

        // var order_id = $(domElement).attr('order_id');
        //   var tmp = getBackorderDivs(order_id);
        //   var backorderDivId = tmp.backorderDivId;
        //   $('#' + backorderDivId + ' input.backorder').each(function(index, element) {
        //       var product_allowed_country_account_show = $(element).attr('product_allowed_country_account_show');
        //       var account_stock_unpacked_unreserved = $(element).attr('account_stock_unpacked_unreserved');
        //       if (product_allowed_country_account_show == "" && account_stock_unpacked_unreserved > 0) {
        //           $(element).attr('checked', true);
        //       }
        //   });

        // Select only the backorder that product_allowed_country_account_show is empty and account_stock_unpacked_unreserved > 0 
        this.selectedBackOrders = new Set(
          this.selectedOrder?.get_backorders?.backorders
            .filter(
              (e) =>
                e.product_allowed_country_account_show == "" &&
                e.account_stock_unpacked_unreserved > 0
            )
            .map((e) => e.backorder_id)
        );

      } else if (menu == 'add_backorders') {
        this.$emit("add_backorders", {
          order_id:
            this.selectedOrder?.order_details_tab_summary?.order?.order_id,
          backorders: [...this.selectedBackOrders],
        });
      }
    },
    onCheckBoxChange: function (e, item) {
      this.selectedBackOrders = addRemoveSet(
        e.target.checked,
        this.selectedBackOrders,
        item.backorder_id
      );

      console.log(e.target.checked, this.selectedBackOrders);
    },
    onTextFieldChange: function (e, item) {
      const { name, value } = e;

      this.$emit("changed", { name, value, item });
    },

    deleteBackorder: async function (item) {
      const confirmationResult = await confirmDelete(
        "BackOrder",
        item.backorder_id
      );

      if (confirmationResult === "yes") {
        this.$emit("delete", {
          item: item,
          order_id:
            this.selectedOrder?.order_details_tab_summary?.order?.order_id,
        });
      }
    },
  },
};
</script>
